import { type ReactNode, forwardRef } from 'react'
import * as BaseScrollArea from '@radix-ui/react-scroll-area'

interface ScrollAreaProps {
  children: ReactNode
  className?: string
}

const HorizontalScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ children, className }, ref) => {
    const combinedClassName = `h-scroll-area ${className}`
    return (
      <BaseScrollArea.Root className={combinedClassName}>
        <BaseScrollArea.Viewport
          className="viewport h-full min-w-full overflow-x-auto"
          ref={ref}
        >
          {children}
        </BaseScrollArea.Viewport>
        <BaseScrollArea.Scrollbar
          className="scrollbar"
          orientation="horizontal"
        >
          <BaseScrollArea.Thumb className="thumb" />
        </BaseScrollArea.Scrollbar>
        <BaseScrollArea.Corner />
      </BaseScrollArea.Root>
    )
  }
)

HorizontalScrollArea.displayName = 'HorizontalScrollArea'

export default HorizontalScrollArea
